import Data from "../types/Data";
import getAllGroupsById from "./getAllGroupsById";

export default function getUserGroups(data: Data) {
  const groupIds = data.groupIds;
  const Group = getAllGroupsById(data);
  return groupIds.map((id) => Group[id]);
}
